import React, { useState } from "react";
import "../../Styles/SurveyFeedbackForm.css";

const AdminSurveyFeedbackForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    voterId:"",
    category: "",
    type: "",
    rating: "",
    village: "",
    mandal: "",
    date: "",
    status: "",
    details: "",
    photo: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="survey-form-container">
      <div className="survey-form-card">
        <div className="survey-form-header">
          <h2>Add New Survey / Feedback</h2>
          <p>Record citizen feedback, suggestions, or complaints</p>
          <button
            className="survey-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="survey-form-grid">

            <div className="survey-form-group">
              <label>Respondent Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Enter Name"
                onChange={handleChange}
              />
            </div>
            <div className="survey-form-group">
              <label>VoterId *</label>
              <input
                type="text"
                name="voterId"
                placeholder="Enter Voter Id "
                onChange={handleChange}
              />
            </div>

            <div className="survey-form-group">
              <label>Mobile Number *</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                onChange={handleChange}
              />
            </div>

            <div className="survey-form-group">
              <label>Category *</label>
              <select name="category" onChange={handleChange}>
                <option>Select Category</option>
                <option>Road Development</option>
                <option>Drinking Water</option>
                <option>Electricity</option>
                <option>Health Camp</option>
                <option>Education</option>
                <option>Sanitation</option>
                <option>General</option>
              </select>
            </div>

            <div className="survey-form-group">
              <label>Feedback Type *</label>
              <select name="type" onChange={handleChange}>
                <option>Select Type</option>
                <option>Complaint</option>
                <option>Suggestion</option>
                <option>Appreciation</option>
              </select>
            </div>

            <div className="survey-form-group">
              <label>Satisfaction Rating *</label>
              <select name="rating" onChange={handleChange}>
                <option>Select Rating</option>
                <option>Satisfied</option>
                <option>Neutral</option>
                <option>Dissatisfied</option>
              </select>
            </div>

            <div className="survey-form-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="survey-form-group">
              <label>Mandal *</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

            <div className="survey-form-group">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                onChange={handleChange}
              />
            </div>

            <div className="survey-form-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Reviewed</option>
                <option>Pending</option>
              </select>
            </div>

            <div className="survey-form-group">
              <label>Upload Photo</label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="survey-form-group survey-full-width">
            <label>Feedback Details *</label>
            <textarea
              rows="4"
              name="details"
              placeholder="Describe the feedback, complaint, or suggestion"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="survey-btn-group">
            <button type="submit" className="survey-submit-btn">
              Submit
            </button>
            <button type="reset" className="survey-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminSurveyFeedbackForm;